import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [
    "rowTypeSelect", "vatTypeLabel", "vatTypeSelect", "userSelectLabel", "userSelect"
  ]

  // Sélection d'un type de row_type
  row_type_change(e) {
    if (this.rowTypeSelectTarget.value == "debours") {
      this.vatTypeLabelTarget.classList.remove("required")
      this.userSelectLabelTarget.classList.remove("required")
      this.vatTypeSelectTarget.value = null
      this.userSelectTarget.value = null
    }
    else {
      this.vatTypeLabelTarget.classList.add("required")
      this.userSelectLabelTarget.classList.add("required")
    }
  }

}